// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f2-j";
export var fulfillmentFormRail = "_f2-i";
export var headerTitleRow = "_f2-l";
export var orderDetailsWrapper = "_f2-g";
export var orderLinkTrigger = "_f2-2";
export var paymentInformationGrid = "_f2-q";
export var paymentSummaryColumn = "_f2-r";
export var phoneShipmentPickerButton = "_f2-e";
export var phoneShipmentPickerButtonContent = "_f2-f";
export var phoneShipmentPickerButtonWrapper = "_f2-d";
export var phoneShipmentPickerTrigger = "_f2-c";
export var shipmentContainer = "_f2-k";
export var shipmentDetailsMainPane = "_f2-h";
export var shipmentNavigationCard = "_f2-a";
export var shipmentNavigationEdgeTrigger = "_f2-6";
export var shipmentNavigationRail = "_f2-3";
export var shipmentNavigationRailEnter = "_f2-5";
export var shipmentNavigationRailHeader = "_f2-9";
export var shipmentNavigationRailOverlay = "_f2-4";
export var shipmentNavigationScrim = "_f2-7";
export var shipmentSummaryFact = "_f2-n";
export var shipmentSummaryGrid = "_f2-m";
export var shipmentSummaryMetadataRow = "_f2-o";
export var shipmentSummaryTags = "_f2-p";
export var shipmentWorkspace = "_f2-0";
export var shipmentWorkspaceBodyTablet = "_f2-8";
export var shipmentWorkspaceContent = "_f2-b";
export var shipmentWorkspaceHeader = "_f2-1";